import Repository from "../../repository";

export default {
    ReportDetected: (payload) => Repository.post(`/api/StationDataGasFoodCourt/ReportDetected`, payload),
    ReportUsed: (payload) => Repository.post(`/api/StationDataGasFoodCourt/ReportUsed`, payload),
    ReportDebits: (payload) => Repository.post(`/api/StationDataGasFoodCourt/ReportDebits`, payload),
    LogDetected: (payload) => Repository.post(`/api/StationDataGasFoodCourt/LogDetected`, payload),
    HistoryGasFoodCourt: (payload) => Repository.post(`/api/StationDataGasFoodCourt/HistoryGasFoodCourt`, payload),
}
